import { Outlet, Navigate, Link } from 'react-router-dom';
import { useAuthStore } from '@/stores/auth';

export default function AuthLayout() {
  const { isAuthenticated, user, isLoading } = useAuthStore();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-cream">
        <div className="w-12 h-12 border-4 border-rust/20 border-t-rust rounded-full animate-spin" />
      </div>
    );
  }

  if (isAuthenticated && user) {
    if (user.role === 'superadmin') {
      return <Navigate to="/admin" replace />;
    } else if (user.role === 'org_admin') {
      return <Navigate to="/org" replace />;
    } else {
      return <Navigate to="/dashboard" replace />;
    }
  }

  return (
    <div className="min-h-screen flex">
      {/* Left side - branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-charcoal p-12 flex-col justify-between relative overflow-hidden">
        {/* Background glow */}
        <div className="absolute -top-1/2 -right-1/2 w-full h-[200%] bg-gradient-rust opacity-10" />

        <div className="relative z-10">
          <Link to="/" className="font-display text-2xl font-bold text-warm-white tracking-tight">
            venndela
          </Link>
          <p className="text-tan mt-2">Turn customers into advocates.</p>
        </div>

        <div className="space-y-6 relative z-10">
          <div className="bg-white/5 backdrop-blur rounded-lg p-6 border border-white/10">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-rust flex items-center justify-center">
                <svg className="w-6 h-6 text-warm-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
              </div>
              <div>
                <h3 className="text-warm-white font-display font-bold">Track Performance</h3>
                <p className="text-tan text-sm">Real-time analytics and insights</p>
              </div>
            </div>
          </div>

          <div className="bg-white/5 backdrop-blur rounded-lg p-6 border border-white/10">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-sage flex items-center justify-center">
                <svg className="w-6 h-6 text-warm-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <div>
                <h3 className="text-warm-white font-display font-bold">Automatic Payouts</h3>
                <p className="text-tan text-sm">Seamless Stripe integration</p>
              </div>
            </div>
          </div>

          <div className="bg-white/5 backdrop-blur rounded-lg p-6 border border-white/10">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-tan flex items-center justify-center">
                <svg className="w-6 h-6 text-charcoal" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
              <div>
                <h3 className="text-warm-white font-display font-bold">Manage Affiliates</h3>
                <p className="text-tan text-sm">Complete affiliate management</p>
              </div>
            </div>
          </div>
        </div>

        <p className="text-tan/50 text-sm relative z-10">
          © {new Date().getFullYear()} Venndela. All rights reserved.
        </p>
      </div>

      {/* Right side - auth forms */}
      <div className="flex-1 flex items-center justify-center p-8 bg-cream">
        <div className="w-full max-w-md">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
